import { Component } from '@angular/core';
import { TauresFooterModule } from '@taures/taures-components/taures-footer';

@Component({
  selector: 'app-footer',
  imports: [TauresFooterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {}
